<template>
  <div class="audio-player" @contextmenu.prevent>
    <div class="icon" @click.stop="playAudioOrPausedAudio">
      <img :src="playing ? pauseIcon  : playIcon" />
    </div>
    <div class="progress-outer" @click.stop="changePlayProgress">
      <div class="progress-inner" :style="{ width: `${progress}%` }"></div>
    </div>
    <div class="time">{{playTime}}/{{totalTime}}</div>

    <audio :src="mediaPath"></audio>
  </div>
</template>

<script>
import { formatSecond } from '../../../../../utils';
import playIcon from '../../../../../assets/image/play-audio.png';
import pauseIcon from '../../../../../assets/image/pause-audio.png';

export default {
  name: 'AudioPlayer',
  props: {
    mediaPath: { type: String, required: true },
  },
  data() {
    return {
      playIcon,
      pauseIcon,
      audio: null,
      playing: false,
      duration: 0,
      currentTime: 0,
    };
  },
  computed: {
    progress() {
      return (this.currentTime / this.duration) * 100;
    },
    totalTime() {
      return formatSecond(this.duration);
    },
    playTime() {
      return formatSecond(this.currentTime);
    },
  },
  methods: {
    playAudioOrPausedAudio() {
      if (!this.audio) {
        this.audio = this.$el.querySelector('audio');
      }

      if (this.playing) {
        this.audio.pause();
        this.playing = false;
      } else {
        this.audio.play();
        this.playing = true;
      }
    },
    changePlayProgress({ offsetX, currentTarget }) {
      this.audio.currentTime = offsetX / currentTarget.clientWidth * this.duration;
    },
  },
  mounted() {
    this.audio = this.$el.querySelector('audio');

    this.audio.addEventListener('loadeddata', ({ target }) => {
      this.duration = target.duration;
    });

    this.audio.addEventListener('timeupdate', ({ target }) => {
      this.currentTime = target.currentTime;
    });
  },
};
</script>

<style lang="less" scoped>
.audio-player {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  max-width: 420px;
  width: 100%;
  padding: 6px 8px;
  border-radius: 4px;
  background-color: #fff;

  > .icon {
    margin-right: 8px;
    width: 26px;
    height: 26px;
    cursor: pointer;

    > img {
      width: 100%;
      height: 100%;
    }
  }

  > .progress-outer {
    position: relative;
    flex: 1;
    height: 2px;
    border-radius: 4px;
    background-color: rgba(12, 140, 202, .1);
    cursor: pointer;

    > .progress-inner {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      background-color: rgba(12, 140, 202, 1);
      transition: all .2s linear;
    }
  }

  > .time {
    margin-left: 12px;
    font-size: 12px;
  }
}
</style>
